import * as actionTypes from "./actionTypes";

//*  ACTIVITY DETAILED WORKING TIME TRENDS *//

export const fetchReferenceEntries = (payload) => {
  return {
    type: actionTypes.FETCH_REFERENCE_ENTRIES,
    payload,
  };
};

export const fetchReferenceEntriesSuccess = (payload) => {
  return {
    type: actionTypes.FETCH_REFERENCE_ENTRIES_SUCCESS,
    payload,
  };
};

export const fetchReferenceEntriesFailed = (payload) => {
  return {
    type: actionTypes.FETCH_REFERENCE_ENTRIES_FAILED,
    payload,
  };
};

export const createReferenceEntry = (payload) => {
  return {
    type: actionTypes.CREATE_REFERENCE_ENTRY,
    payload,
  };
};

export const createReferenceEntrySuccess = (payload) => {
  return {
    type: actionTypes.CREATE_REFERENCE_ENTRY_SUCCESS,
    payload,
  };
};

export const createReferenceEntryFailed = (payload) => {
  return {
    type: actionTypes.CREATE_REFERENCE_ENTRY_FAILED,
    payload,
  };
};

export const deleteReferenceEntry = (payload) => {
  return {
    type: actionTypes.DELETE_REFERENCE_ENTRY,
    payload,
  };
};

export const deleteReferenceEntrySuccess = (payload) => {
  return {
    type: actionTypes.DELETE_REFERENCE_ENTRY_SUCCESS,
    payload,
  };
};

export const deleteReferenceEntryFailed = (payload) => {
  return {
    type: actionTypes.DELETE_REFERENCE_ENTRY_FAILED,
    payload,
  };
};

export const updateReferenceEntry = (payload) => {
  return {
    type: actionTypes.UPDATE_REFERENCE_ENTRY,
    payload,
  };
};

export const updateReferenceEntrySuccess = (payload) => {
  return {
    type: actionTypes.UPDATE_REFERENCE_ENTRY_SUCCESS,
    payload,
  };
};

export const updateReferenceEntryFailed = (payload) => {
  return {
    type: actionTypes.UPDATE_REFERENCE_ENTRY_FAILED,
    payload,
  };
};

export const setErrorMessage = (payload) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGE,
    payload,
  };
};
